<!--
@Author: Liao Hui
@Date:   2019-03-13T11:03:22+08:00
@Last modified by:   Liao Hui
@Last modified time: 2019-03-13T15:11:37+08:00
-->

<template>
  <div class="cp-select" :class="{ isopen: isDrop }">
    <div
      :class="['selection-show', isDrop ? 'isopen' : '']"
      @click="toggleDrop"
    >
      <span>{{
        key
          ? `${options[nowIndex].zone_name || options[nowIndex].role_name}`
          : placeholder
      }}</span>
      <div :class="['arrow', isDrop ? 'isopen' : '']"></div>
      <div class="divider" v-show="isDrop && nowIndex > 0"></div>
    </div>
    <div class="selection-list" v-show="isDrop">
      <ul v-if="options">
        <li
          :class="['selection-item', index == nowIndex ? 'selected' : '']"
          v-for="(item, index) in options"
          :key="item.val"
          @click="chooseSelection(index, item)"
        >
          {{ item.zone_name || item.role_name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { setStore } from "~/tools/utils";
export default {
  props: {
    options: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    close: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isDrop: false,
      nowIndex: 0,
      key: null,
    };
  },
  watch: {
    close: {
      handler(value) {
        if(this.close) {
          this.isDrop = false
        }
      },
      deep: true
    },
    options: {
      handler(value) {
        if(value && value.length) {
          this.chooseSelection(0, value[0])
        }
      },
      deep: true
    },
  },
  mounted() {
  },
  methods: {
    toggleDrop() {
      this.isDrop = !this.isDrop;
      this.$emit("toggle", this.isDrop);
    },
    chooseSelection(index, item) {
      this.nowIndex = index;
      this.key = item;
      this.isDrop = false;
      this.$emit("select", item);
      // setStore('data-id', key)
    },
  },
};
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
.cp-select
    width 3.9rem
    height 0.81rem
    background-color: #fff;
    font-size 0.26rem
    color #333
    line-height 0.81rem
    border 0.01rem solid #e2cdac
    cursor pointer
    .mr20
      margin-right 0.20rem
    .divider
        width 3.9rem;
        height 0.01rem;
        position absolute
        bottom 0;
    .selection-show
        height 100%
        width 100%
        text-align center
        position relative
        display flex
        align-items center
        color: #333;
        padding-left 0.25rem
        font-weight bold
        .arrow
            cursor: pointer;
            pointer-events: all;
            height: 0.12rem
            width 0.19rem
            background url('./images/arrow.png')
            background-size 100% 100%
            outline none
            transition: all .3s ease;
            position absolute
            right 0.21rem
            &.isopen
                transform rotate(180deg)
    .selection-list
        position absolute
        width 3.9rem
        z-index 1
        background-color #fff
        height 2.8rem
        overflow auto
        border 0.01rem solid #e2cdac
        margin-top 0.01rem
        margin-left -0.01rem
        &.positive
            top 0.81rem
        &.reverse
            bottom 0.81rem
        .selection-item
            height 0.81rem
            width 100%
            padding-left: 0.25rem
            line-height 0.81rem
            color: #333;
            font-size 0.24rem
            text-align left
            &:hover
              background-color #f4eddf
            &.selected
                background-color #ead8b4
</style>
